import { push } from 'react-router-redux'

import { PASSWORD_CHANGE_FULFILLED, SIGN_OUT, signOut } from 'Global/Stores/auth'

const authMiddlewares = ({ dispatch, getState }) => next => action => {
  if (action.type === PASSWORD_CHANGE_FULFILLED) {
    dispatch(signOut())

    return
  }

  if (action.type === SIGN_OUT) {
    dispatch(push('/signIn'))

    return next(action)
  }

  return next(action)
}

export default authMiddlewares
